export default "__VITE_ASSET__dfa8e1bf__"